import React from 'react';
import PropTypes from 'prop-types';
import './skeleton.css';

/* Skeleton — one block of the shape that is loading.
   A skeleton is not announced: the region it sits in carries the `aria-busy`
   wiring, so each block is hidden from the accessibility tree — otherwise a
   screen reader reads a dozen empty boxes before the content arrives. */
export default function Skeleton({ w, h, shape, className, style }) {
  return (
    <span
      aria-hidden="true"
      className={[
        'sd-skel',
        shape === 'circle' ? 'sd-skel-circle' : '',
        shape === 'tile' ? 'sd-skel-tile' : '',
        className,
      ].filter(Boolean).join(' ')}
      style={{ width: w, height: h, ...style }}
    />
  );
}

Skeleton.propTypes = {
  w: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  h: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  shape: PropTypes.oneOf(['rect', 'circle', 'tile']),
  className: PropTypes.string,
  style: PropTypes.object,
};

Skeleton.defaultProps = { w: '100%', h: 12, shape: 'rect' };
